const solutions = [
  {
    title: 'ディープラーニング異常検知',
    subtitle: '99.8%の精度でリスクを捕捉',
    tag: 'AI',
    variant: 'dark',
  },
  {
    title: 'スケーラブル分析基盤',
    subtitle: '毎秒100万件の取引を処理',
    tag: 'クラウド',
    variant: 'image',
    seq: 'solution-cloud',
    query: 'Professional%20photography%20of%20a%20modern%20cloud%20computing%20data%20center%20with%20server%20racks%20and%20blue%20LED%20lights%2C%20clean%20organized%20layout%2C%20depth%20of%20field%2C%20dark%20ambient%20lighting%2C%20technology%20infrastructure%2C%20no%20people%2C%20high-end%20enterprise%20aesthetic',
  },
  {
    title: 'コンプライアンス対応',
    subtitle: '金融庁ガイドライン準拠',
    tag: '法務',
    variant: 'text',
  },
];

export default function SolutionsSection() {
  return (
    <section id="solutions" className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        {/* Header */}
        <div className="mb-12 md:mb-16">
          <p className="text-xs md:text-sm text-foreground-400 tracking-[0.15em] font-sans font-light mb-2">BANKCARD CHECK</p>
          <h3 className="text-xl md:text-3xl lg:text-4xl font-heading font-light text-foreground-950 tracking-[0.06em]">
            ソリューション
          </h3>
        </div>

        {/* 3 Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {/* Card 1 - Dark */}
          <div className="group relative rounded-lg overflow-hidden bg-primary-900 p-8 md:p-10 flex flex-col justify-between min-h-[360px] md:min-h-[420px] cursor-pointer">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-foreground-700/30 flex items-center justify-center">
              <span className="text-accent-400 text-sm md:text-base font-heading tracking-[0.1em]">{solutions[0].tag}</span>
            </div>
            <div>
              <h4 className="text-xl md:text-2xl text-white tracking-[0.06em] font-heading font-light leading-relaxed">{solutions[0].title}</h4>
              <p className="mt-3 text-xs md:text-sm text-foreground-400 tracking-[0.06em] font-sans font-light">{solutions[0].subtitle}</p>
            </div>
          </div>

          {/* Card 2 - Image Background */}
          <div className="group relative rounded-lg overflow-hidden min-h-[360px] md:min-h-[420px] cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20photography%20of%20a%20modern%20cloud%20computing%20data%20center%20with%20server%20racks%20and%20blue%20LED%20lights%2C%20clean%20organized%20layout%2C%20depth%20of%20field%2C%20dark%20ambient%20lighting%2C%20technology%20infrastructure%2C%20no%20people%2C%20high-end%20enterprise%20aesthetic&width=600&height=800&seq=solution-cloud&orientation=portrait"
              alt="クラウド分析基盤"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-primary-900/50" />
            <div className="absolute top-4 left-4">
              <span className="inline-block px-3 py-1 rounded-full bg-primary-900/70 backdrop-blur-sm text-accent-400 text-[11px] md:text-xs tracking-[0.1em] font-sans font-light">
                {solutions[1].tag}
              </span>
            </div>
            <div className="absolute bottom-8 left-8 right-8">
              <h4 className="text-xl md:text-2xl text-white tracking-[0.06em] font-heading font-light leading-relaxed">{solutions[1].title}</h4>
              <p className="mt-3 text-xs md:text-sm text-white/70 tracking-[0.06em] font-sans font-light">{solutions[1].subtitle}</p>
            </div>
          </div>

          {/* Card 3 - Text based */}
          <div className="group relative rounded-lg overflow-hidden bg-background-100 p-8 md:p-10 flex flex-col justify-between min-h-[360px] md:min-h-[420px] cursor-pointer">
            <h4 className="text-xl md:text-2xl text-foreground-950 tracking-[0.06em] font-heading font-light leading-relaxed">{solutions[2].title}</h4>
            <div>
              <p className="text-xs md:text-sm text-foreground-500 tracking-[0.06em] font-sans font-light mb-4">{solutions[2].subtitle}</p>
              <div className="w-full aspect-[16/9] rounded-md overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20photography%20of%20a%20clean%20modern%20Japanese%20office%20with%20legal%20documents%20and%20contracts%20on%20a%20wooden%20desk%2C%20fountain%20pen%2C%20warm%20ambient%20lighting%2C%20minimalist%20composition%2C%20corporate%20law%20aesthetic%2C%20no%20people%2C%20professional%20Japanese%20business%20setting&width=640&height=360&seq=solution-compliance&orientation=landscape"
                  alt="コンプライアンス"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}